<template>
    <div
        class="d-flex flex-column"
    >
        <div class="my-1">
            <div class="media">
                <div class="media-aside mr-2 align-self-start">
                    <span class="b-avatar badge-light-secondary rounded-circle" :style="`background-color:${barColors['Last Month']};width: 32px; height: 32px;`">
                        <span class="b-avatar-custom">
                        </span>
                    </span>
                </div>
                <div class="media-body my-auto">
                    <h5 class="font-weight-bolder mb-0">
                        {{ __toKFormat(cumulativeCost.prevMonthCost || 0) }}
                    </h5>
                    <p class="card-text font-small-2 mb-0">
                        {{ $t('v4.Last Month') }}
                    </p>
                </div>
            </div>
        </div>
        <div class="my-1">
            <div class="media">
                <div class="media-aside mr-2 align-self-start">
                    <span class="b-avatar badge-light-secondary rounded-circle" :style="`background-color:${barColors.Current};width: 32px; height: 32px;`">
                        <span class="b-avatar-custom">
                        </span>
                    </span>
                </div>
                <div class="media-body my-auto">
                    <h5 class="font-weight-bolder mb-0">
                        {{ __toKFormat(cumulativeCost.currentMonthCost || 0) }}
                    </h5>
                    <p class="card-text font-small-2 mb-0">
                        {{ $t('v4.Current') }}
                    </p>
                </div>
            </div>
        </div>
        <div class="my-1" v-if="estimated && cumulativeCost.estimatedCost">
            <div class="media">
                <div class="media-aside mr-2 align-self-start">
                    <span class="b-avatar badge-light-secondary rounded-circle" :style="`background-color:${barColors['Estimated Cost']};width: 32px; height: 32px;`">
                        <span class="b-avatar-custom">
                        </span>
                    </span>
                </div>
                <div class="media-body my-auto">
                    <h5 class="font-weight-bolder mb-0">
                        {{ __toKFormat(cumulativeCost.estimatedCost || 0) }}
                    </h5>
                    <p class="card-text font-small-2 mb-0">
                        {{ $t('v4.Estimated') }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useCommonData from '@/composables/useCommonData'
import { computed, toRefs } from '@vue/composition-api'
export default {
    components: {
    },
    props: {
        themeColors: {
            type: Object,
            default: function () {
                return {}
            }
        },
        theme: {
            type: String
        },
        cumulativeCost: {
            type: Object,
            default: function () {
                return {
                    currentMonthCost: 0,
                    estimatedCost: 0,
                    prevMonthCost: 0
                }
            }
        },
        estimated: {
            type: Boolean
        },
        status: {
            type: [String, Number],
            default: ''
        }
    },
    setup (props, context) {
        const { __toKFormat } = useCommonData()
        const { themeColors } = toRefs(props)
        const barColors = computed(() => {
            return {
                'Estimated Cost': '#d1cdfa',
                'Current': themeColors.value.primary,
                'Last Month': themeColors.value.secondary
            }
        })
        return {
            __toKFormat,
            barColors
        }
    }
}
</script>

<style>

</style>
